import { fetcher } from '@commenda/utils';

import { TIndirectTaxProductsBulkUpdateProps } from './types';

type BulkProductResult = {
  success: boolean;
  message?: string;
  error?: string;
};

export async function bulkUpdateIndirectTaxProducts(
  body: TIndirectTaxProductsBulkUpdateProps,
  token?: string
): Promise<BulkProductResult> {
  try {
    const response = await fetcher(
      'new-sales-tax/products/bulk/update',
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to bulk update products',
      };
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || 'Products updated successfully',
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to bulk update products';
    return { success: false, error: errorMessage };
  }
}
